import { ReactNode } from 'react';
import { Translate } from 'next-translate';
import { MenuItemConfig } from 'handsontable/plugins/contextMenu';

import { getRendererWithIcon } from './getRendererWithIcon';

export const defaultMenuItem = (t: Translate, value: string, icon?: ReactNode): MenuItemConfig => {
  const name = t(`bid_request.line_items.dropdown.${value}`);
  const tooltip = t('bid_request.line_items.feature_not_implemented');

  return {
    disabled: true,
    name,
    renderer: (_hot: unknown, wrapper: HTMLElement): HTMLElement => (
      getRendererWithIcon({ icon, name, tooltip, wrapper })
    ),
  };
};
